export default function (html, data) {
    if (data.location && data.location.industry && !data.industry) {
        data.industry = data.location.industry;
    }

    if (data.industry) {
        html.find('[html="industry.name"]')
            .html(data.industry.name)
            .prev().css('background-color', data.industry.color);
    } else {
        html.find('[html="industry.name"]')
            .html('Все индустрии')
            .prev().addClass('bg-border-gray');
    }

    if (data.isLive) {
        html.attr({
            'live-open': data.id,
            'data-json': JSON.stringify(data)
        });
    } else {
        if (!data.isFuture) {
            html.attr({
                'video-open': data.id,
                'data-json': JSON.stringify(data)
            });
        }
    }

    return html;
}